import React, { useContext } from 'react'
import AccessContext from '../../context/AccessContext/AccessContext';
import { getTenantInfoByKey } from '../../helpers/helpers';
import ItemSelectableSimple from '../ItemSelectable/ItemSelectableSimple'

const ContractorsSelectable = () => {

    const { accessState, setAccessEmployee, setExitEmployee } = useContext(AccessContext);
    const { contractors, type } = accessState;

    const isExit = type === 'EXIT';

    const handleSetEmployee = (employee) => {
        if (isExit) {
            setExitEmployee(employee)
        } else {
            setAccessEmployee(employee);
        }
    }

    return (
        <div className='d-flex flex-column gap-3'>
            {
                contractors.map((contractorEmployee, idx) =>
                    <ItemSelectableSimple key={idx} onClick={() => handleSetEmployee(contractorEmployee)}>
                        <div>
                            <div className='d-flex align-items-baseline gap-2'>
                                <h6
                                    className='custom-h6 black-color'
                                >
                                    {contractorEmployee.contractor_name}
                                </h6>
                                <span className='blue-dark-text'>
                                    {
                                        contractorEmployee.contractor_natural_id ?
                                            `${getTenantInfoByKey('contractor_id_lbl')}: ${contractorEmployee.contractor_natural_id}`
                                            :
                                            null
                                    }
                                </span>
                            </div>
                            <div>
                                <p className='blue-dark-text m-0'>{contractorEmployee.fullname}</p>
                                <p className='subtitle m-0'>
                                    {
                                        contractorEmployee.natural_id ?
                                            `${getTenantInfoByKey('employee_id_lbl')}: ${contractorEmployee.natural_id}`
                                            :
                                            null
                                    }
                                </p>
                            </div>
                        </div>
                    </ItemSelectableSimple>
                )
            }
        </div>
    )
}

export default ContractorsSelectable